import { render, staticRenderFns } from "./UserListModal.vue?vue&type=template&id=036fec7f&"
import script from "./UserListModal.vue?vue&type=script&lang=js&"
export * from "./UserListModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports